export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"facebook-domain-verification","content":"f2kkcwl6dgg8tbnpnmmjymugyeetkj"}],"link":[{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossOriginIsolated":true},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Crimson+Text:wght@400;500;700&family=Jost:wght@400;500;700&display=swap"},{"rel":"stylesheet","href":"/css/symbolFont.css?v=2"},{"rel":"stylesheet","href":"/css/icomoon.css"}],"style":[],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = false

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const vueAppRootContainer = '#__nuxt'